import React from 'react';
import { components } from 'react-select';

const AutocompletItem = (props) => {
    const item = props.data;
    const classes = [];

    classes.push('suggestion-item');

    if (item.displayClass !== undefined) {
        classes.push(item.displayClass);
    }
    if (props.isFocused) {
        classes.push('active');
    }
    return (
        <components.Option className={classes.join(' ')} key={item.index} id={item.value} {...props}>
            {(item.label && (
                <div dangerouslySetInnerHTML={{ __html: item.label }} />
            )) || (
                <>
                    <div className="autocomplete-text">{item.text}</div>
                    <small className="sub-text">{item.text2}</small>
                </>
            )}
            {item.icon && (
                <svg className="icon" width="100%" height="100%" xmlns="http://www.w3.org/1999/xlink" xmlnsXlink="http://www.w3.org/1999/xlink">
                    <use xlinkHref={`/img/icons/icon-defs.svg#${item.icon}`} />
                </svg>
            )}
        </components.Option>
    );
};

export default AutocompletItem;
